import {Component, forwardRef, OnChanges, SimpleChanges, AfterViewInit} from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';
import { ExpressionEvaluatorModel } from '../expression-evaluator.model';
import * as ExprParser from 'expr-eval';
import * as moment from 'moment';
import { takeUntil, filter } from 'rxjs/operators';
import { Model_WorkflowComponent } from 'src/app/app.models';
import { EventWorkflowValuesChanged } from '../../workflow-components.service';

@Component({
    selector: 'abw-expression-evaluator-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => ExpressionEvaluatorFormComponent),
        multi: true
      },
      {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => ExpressionEvaluatorFormComponent),
        multi: true
      }
    ],
    templateUrl: './expression-evaluator-form.component.html',
    styleUrls: ['./expression-evaluator-form.component.scss']
})
export class ExpressionEvaluatorFormComponent extends AbstractWorkflowFormComponent<ExpressionEvaluatorModel, string> implements AfterViewInit {

    parser: ExprParser.Parser;
    functions = ['CONCAT', 'DATE', 'PADLEFT', 'TIMESTAMP', 'GENCODE', 'UPPERCASE', 'LOWERCASE'];

    ngOnInit() {
        super.ngOnInit();
        const parser = new ExprParser.Parser();
        parser.functions.CONCAT = function (...args) {
            let res = "";
            for (var a in args) {
                res += args[a];
            }
            return res;
        };
        parser.functions.DATE = function (format: string) {
            return moment().format(format);
        };
        parser.functions.PADLEFT = function (str: any, length: number, fillChar: string) {
            return (str + "").padStart(length, fillChar);
        };
        parser.functions.TIMESTAMP = function () {
            return (Math.floor(Date.now() / 1000) + "")
        };
        parser.functions.GENCODE = function(length: number) {
            let result = '';
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const charactersLength = characters.length;
            let counter = 0;
            while (counter < length) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
            }
            return result;
        }
        parser.functions.UPPERCASE = function (str?: string) {
            if (!str) { return ''; }
            return str.toUpperCase();
        };
        parser.functions.LOWERCASE = function (str?: string) {
            if (!str) { return ''; }
            return str.toLowerCase();
        };
        this.parser = parser;
    }

    ngAfterViewInit() {
        this._workflowComponentsService.workflowValuesChanged$.pipe(
            takeUntil(this.onComplete),
            filter(_change => {
                const workflowComponent = (this.model as any).additional as Model_WorkflowComponent;
                const formGroupId = workflowComponent.FORM_ID || '_FORM_';
                return !!_change.sender && !!_change.sender.FORM_ID && _change.sender.FORM_ID == formGroupId && _change.sender.ID != this.model.id;
            })
        ).subscribe(_change => {
            this._evaluateValue(_change);
        });
        this._evaluateValue(this._workflowComponentsService.context, true);
    }

    private _evaluateValue(_change: EventWorkflowValuesChanged, _init?: boolean) {
        const workflowComponent = (this.model as any).additional as Model_WorkflowComponent;
        let formGroupId = workflowComponent.FORM_ID || '_FORM_';
        let exprValueChanged: string = this.model.additional.EXPRESSION_VALUE;
        const regex = /\@\[([\w]+)\]/g;
        let computedControls = exprValueChanged.match(regex);
        if ((!!_change && !!_change.formValues && !!_change.formValues[formGroupId]) && (_init == true || (!!computedControls && computedControls.lastIndexOf(`@[${_change.sender.ID}]`) > -1))) {
            let expression = exprValueChanged;
            if (!!computedControls) {
                computedControls.map(matched => matched.substr(2, matched.length - 3)).forEach((field) => {
                    let fieldValue = !!_change?.formValues && !!_change.formValues[formGroupId] ? _change.formValues[formGroupId][field] : null;
                    if (!!fieldValue) {
                        expression = expression.replace(new RegExp('\\@\\[' + field + '\\]', 'g'), `'${fieldValue}'`);
                    } else {
                        expression = expression.replace(new RegExp('\\@\\[' + field + '\\]', 'g'), "' '");
                    }
                });
            }
            exprValueChanged = expression;
            exprValueChanged = exprValueChanged.replace(new RegExp('\\@', 'g'), '');
            exprValueChanged = exprValueChanged.replace(new RegExp('\\#', 'g'), '');
            this.functions.forEach(fn => { exprValueChanged = exprValueChanged.replace(new RegExp(fn, 'gi'), fn); });
            try {
                const exprChanged = this.parser.parse(exprValueChanged);
                const resChanged = exprChanged.evaluate();
                this.value = resChanged;
                this.onValueChanged(resChanged);
            } catch(e) {
                console.log(e);
            }
        }
    }
    
}